import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { TOOLS_DOMAIN } from './constants';

const selectToolsDomain = state => state[TOOLS_DOMAIN] || initialState;

export const selectDWHStatus = () =>
  createSelector(
    selectToolsDomain,
    d => d.dwhStatus,
  );
